import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
          path: '/home',
          name: 'home',
          component: function () { 
            return import('./views/Home.vue')
          }
        },
        {
          path: '/about',
          name: 'about',
          component: function () { 
            return import('./views/About.vue')
          }
        },
        {
          path: '/business',
          name: 'business',
          component: function () { 
            return import('./views/Business.vue')
          }
        },
        {
          path: '/join',
          name: 'join',
          component: function () { 
            return import('./views/Join.vue')
          }
        },
        {
          path: '/contact',
          name: 'contact',
          component: function () { 
            return import('./views/Contact.vue')
          }
        },
        {
          path: '*',
          redirect: '/home'
        }
  ]
})
